import { createApi } from '@reduxjs/toolkit/query/react';
import * as API from '../../apiCalls/urls/counsellorAdmin';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';



export const counsellorAdminApi = createApi({
  baseQuery,
  reducerPath: 'counsellorAdminApi',
  tagTypes: ['counselorListAdmin', 'counselorDetailsAdmin', 'grades', 'counselorMappingAdmin',
    'counselingListAdmin', 'certificate', 'availability', 'counsellingCount', 'availabilityWeekwise'],
  endpoints: (builder) => ({

    getCounselorList: builder.query({
      query: ({ page = 1, items = 10, filters }) => ({
        url: `${API.COUNSELOR_LIST}?page=${page}&items=${items}`,
        method: 'POST',
        body: filters || {}
      }),
      providesTags: ['counselorListAdmin'],
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0
    }),

    getCounselorDetails: builder.query({
      query: ({ type, cId }) => ({
        url: `${API.COUNSELOR_DETAILS(type)}/${cId}`,
        method: 'GET',
      }),
      providesTags: ['counselorDetailsAdmin'],
    }),
    getCounselorMappings: builder.query({
      query: ({ id, sessionId }) => ({
        url: `${API.COUNSELOR_MAPPING}/${id}`,
        method: 'GET',
        params: sessionId !== null && sessionId !== undefined ? { sessionId } : {},
      }),
      providesTags: ['counselorMappingAdmin'],
    }),

    updateCounselor: builder.mutation({
      query: ({ data, id }) => ({
        url: `${API.UPDATE_COUNSELOR}/${id}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['counselorListAdmin'],
    }),

    createCounselor: builder.mutation({
      query: (data) => ({
        url: API.CREATE_COUNSELOR,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['counselorListAdmin'],
    }),

    updateCounselorContract: builder.mutation({
      query: (data) => ({
        url: API.UPDATE_COUNSELOR_CONTRACT,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['counselorDetailsAdmin'],
    }),

    addCounselorMapping: builder.mutation({
      query: ({ data, id }) => ({
        url: API.ADD_COUNSELOR_MAPPING + "/" + id,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['counselorMappingAdmin'],
    }),

    removeCounselorMapping: builder.mutation({
      query: ({ data, id }) => ({
        url: API.REMOVE_COUNSELOR_MAPPING + "/" + id,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['counselorMappingAdmin'],
    }),

    getGrades: builder.query({
      query: () => ({
        url: API.GET_GRADES,
        method: 'GET',
      }),
      providesTags: ['grades'],
    }),
    getCounselingList: builder.query({
      query: ({ page = 1, items = 10, filters }) => ({
        url: `${API.COUNSELING_LIST}?page=${page}&items=${items}`,
        method: 'POST',
        body: filters || {}
      }),
      providesTags: (result, error, { page, items, filters }) => [
        { type: 'counselingListAdmin', page, items, filters },
      ],
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0
    }),
    getCounselingDetails: builder.query({
      query: (id) => ({
        url: `${API.GET_COUNSELING_DETAILS}/${id}`,
        method: 'GET',
      }),
    }),

    addExperiance: builder.mutation({
      query: ({ data, cId }) => ({
        url: API.ADD_EXPERIENCE + "/" + cId,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['counselorDetailsAdmin'],
    }),

    updateExperiance: builder.mutation({
      query: ({ data, cId }) => ({
        url: API.UPDATE_EXPERIENCE + "/" + cId,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['counselorDetailsAdmin'],
    }),

    deleteExperiance: builder.mutation({
      query: ({ expId, cId }) => ({
        url: API.DELETE_EXPERIENCE + "/" + cId,
        method: 'DELETE',
        body: expId
      }),
      invalidatesTags: ['counselorDetailsAdmin'],
    }),

    addEducation: builder.mutation({
      query: ({ data, cId }) => ({
        url: API.ADD_EDUCATION + "/" + cId,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['counselorDetailsAdmin'],
    }),

    updateEducation: builder.mutation({
      query: ({ data, cId }) => ({
        url: API.UPDATE_EDUCATION + "/" + cId,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['counselorDetailsAdmin'],
    }),

    deleteEducation: builder.mutation({
      query: ({ eduId, cId }) => ({
        url: API.DELETE_EDUCATION + "/" + cId,
        method: 'DELETE',
        body: eduId
      }),
      invalidatesTags: ['counselorDetailsAdmin'],
    }),

    updateCounselorProfile: builder.mutation({
      query: ({ preference, data, cId, bankDetails }) => {
        let body = {};

        if (data) {
          body = data;
        } else if (preference) {
          body.preference = preference;
        }

        if (bankDetails) {
          body.bankDetails = bankDetails;
        }

        return {
          url: API.UPDATE_COUNSELOR_PROFILE + "/" + cId,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['counselorDetailsAdmin'],
    }),

    getCertificatesLists: builder.query({
      query: (cId) => ({
        url: API.GET_CERTIFICATE_LIST + "/" + cId,
        method: 'GET',
      }),
      providesTags: ['certificate'],
    }),

    deleteCertificate: builder.mutation({
      query: ({ certiId, cId }) => ({
        url: API.DELETE_CERTIFICATE + "/" + cId,
        method: 'DELETE',
        body: certiId
      }),
      invalidatesTags: ['certificate'],
    }),

    addCertificate: builder.mutation({
      query: ({ data, cId }) => ({
        url: API.ADD_CERTIFICATE + "/" + cId,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['certificate'],
    }),
    updateCertificate: builder.mutation({
      query: ({ data, cId }) => ({
        url: API.UPDATE_CERTIFICATE + "/" + cId,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['certificate'],
    }),

    getCertificatesLink: builder.mutation({
      query: (certificate) => ({
        url: API.GET_CERTIFICATE_LINK,
        method: 'POST',
        body: certificate
      }),
    }),
    addIntroductoryVideo: builder.mutation({
      query: ({ file, cId }) => ({
        url: API.ADD_INTRODUCTORY_VIDEO + "/" + cId,
        method: 'POST',
        body: file,
      }),
      invalidatesTags: ['counselorDetailsAdmin'],
    }),
    deleteIntroductoryVideo: builder.mutation({
      query: ({ cId }) => ({
        url: API.DELETE_INTRODUCTORY_VIDEO + "/" + cId,
        method: 'DELETE',
        // body: introVId
      }),
      invalidatesTags: ['counselorDetailsAdmin'],
    }),
    updateSocialLink: builder.mutation({
      query: ({ linkData, cId }) => ({
        url: API.UPDATE_SOCIAL_LINK + "/" + cId,
        method: 'POST',
        body: linkData,
      }),
      invalidatesTags: ['counselorDetailsAdmin'],
    }),
    getCounsellingCount: builder.query({
      query: (data) => ({
        url: data ? `${API.GET_COUNSELLOR_COUNT}` : API.GET_COUNSELLOR_COUNT,
        method: 'POST',
        body: data,
      }),
      providesTags: ['counsellingCount'],
      keepUnusedDataFor: 0
    }),

    getCounsellorAvailability: builder.query({
      query: (data) => ({
        url: API.COUNSELLOR_AVAILABILITY,
        method: 'POST',
        body: { counselorId: Number(data) }
      }),
      providesTags: ['availability'],
    }),

    addAvailability: builder.mutation({
      query: ({ data }) => ({
        url: API.ADD_AVAILABILITY,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['availability', 'availabilityWeekwise'],
    }),

    deleteAvailability: builder.mutation({
      query: ({ eventId, cId }) => ({
        url: "/admin/users/availability/delete/" + cId + "/" + eventId,
        method: 'POST',
        // body: data,
      }),
      invalidatesTags: ['availability'],
    }),

    getCounsellorDropdown: builder.mutation({
      query: ({ data }) => ({
        url: API.GET_COUNSELLOR_DROPDOWN,
        method: 'POST',
        body: data,
      }),
      // providesTags: ['slots'],
    }),

    getCounsellorSlots: builder.mutation({
      query: ({ cId, counsellingId }) => ({
        url: API.GET_COUNSELLOR_AVAILABILITY_SLOT + "/" + cId + "/" + counsellingId,
        method: 'GET',
      }),
      // providesTags: ['availability'],
    }),
    updateCounselling: builder.mutation({
      query: ({ data, counsellingId }) => ({
        url: API.UPDATE_COUNSELLING + "/" + counsellingId,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['counsellingCount', 'counselorListAdmin'],
    }),
    assignCounselling: builder.mutation({
      query: (data) => ({
        url: API.ASSIGN_COUNSELLING,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['counselingListAdmin'],
    }),
    cancelCounselling: builder.mutation({
      query: ({ data, counsellingId }) => ({
        url: API.CANCEL_COUNSELLING + "/" + counsellingId,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['counselingListAdmin'],
    }),
    acceptRescheduledCounseling: builder.mutation({
      query: (counselingId) => ({
        url: API.ACCEPT_RESCHEDULED_COUNSELING + counselingId,
        method: 'POST',
      }),
      invalidatesTags: ['counselling', "counsellingCount"],
    }),
    getAvailabilitiesCounts: builder.mutation({
      query: ({ data }) => ({
        url: API.GET_AVAILABILITIES_COUNTS,
        method: 'POST',
        body: data
      }),
      // keepUnusedDataFor: 0
    }),
    getAvailabilitiesSlotLists: builder.mutation({
      query: ({ data, filters }) => {
        const { page, items } = filters;
        return {
          url: `${API.GET_AVAILABILITIES_SLOTS_LIST}?page=${page}&items=${items}`,
          method: 'POST',
          body: data
        };
      },
      keepUnusedDataFor: 0
    }),
    getDashboard: builder.query({
      query: (filter) => ({
        url: API.GET_DASHBOARD,
        method: 'POST',
        body: filter
      }),
      keepUnusedDataFor: 0
    }),
    exportCsv: builder.mutation({
      query: (filter) => ({
        url: API.EXPORT_CSV,
        method: 'POST',
        body: filter
      }),
      keepUnusedDataFor: 0
    }),
    getAvailabilityWeekWise: builder.query({
      query: (data) => ({
        url: "/admin/users/availability/get-week-wise/" + data.cId,
        method: 'POST',
        body: data,
      }),
      providesTags: ['availabilityWeekwise'],
    }),
    getDateWiseCounselingList: builder.query({
      query: (data) => ({
        url: "/admin/counselor/date-wise-counseling-list",
        method: 'POST',
        body: data
      }),
      // invalidatesTags: ['availability'],
      keepUnusedDataFor: 0
    }),
    updateCounselorAvailabilityWeekWise: builder.mutation({
      query: (data) => ({
        url: "/admin/users/availability/update-week-wise/" + data.id,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['availability'],
    }),
    getCounselorEarning: builder.mutation({
      query: ({ counselorId, data }) => ({
        url: `/admin/counselor/earning/${counselorId}`,
        method: 'POST',
        body: data,
      }),
    }),
    auditCounseling: builder.mutation({
      query: ({ counselingId, data }) => ({
        url: `/admin/counselor/audit/${counselingId}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['counselling'],
    }),
    getReportData: builder.query({
      query: (counselingId) => ({
        url: "/counselor/counseling-report/" + counselingId,
        method: 'GET',
      }),

    }),
    getMentorFeedbackData: builder.query({
      query: ({ page, items, payload }) => ({
        url: `/admin/counselor/mentor-feedback-list?page=${page}&items=${items}`,
        method: 'POST',
        body: payload
      }),

    }),
    updateCounselorProfilePicture: builder.mutation({
      query: ({ cId, data }) => ({
        url: "/admin/counselor/profile-picture/" + cId,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['profile'],
    }),
    disableCounselor: builder.mutation({
      query: ({ cId }) => ({
        url: "/admin/counselor/disable-counselor/" + cId,
        method: 'POST',
      }),
      invalidatesTags: ['counselorListAdmin'],
    }),
    deleteSession: builder.mutation({
      query: ({ id, data }) => ({
        url: "/admin/counselor/delete-counseling/" + id,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['counselorListAdmin'],
    }),
  }),
});

export const {
  useGetCounselorListQuery,
  useGetCounselorDetailsQuery,
  useUpdateCounselorMutation,
  useAddCounselorMappingMutation,
  useCreateCounselorMutation,
  useGetGradesQuery,
  useRemoveCounselorMappingMutation,
  useLazyGetCounselorDetailsQuery,
  useGetCounselorMappingsQuery,
  useGetCounselingListQuery,
  useGetCounselingDetailsQuery,
  useAddExperianceMutation,
  useUpdateExperianceMutation,
  useDeleteExperianceMutation,
  useAddEducationMutation,
  useUpdateEducationMutation,
  useDeleteEducationMutation,
  useUpdateCounselorProfileMutation,
  useGetCertificatesListsQuery,
  useDeleteCertificateMutation,
  useAddCertificateMutation,
  useUpdateCertificateMutation,
  useGetCertificatesLinkMutation,
  useAddIntroductoryVideoMutation,
  useDeleteIntroductoryVideoMutation,
  useUpdateSocialLinkMutation,
  useGetCounsellingCountQuery,
  useGetCounsellorAvailabilityQuery,
  useAddAvailabilityMutation,
  // useUpdateAvailabilityMutation,
  useGetCounsellorDropdownMutation,
  useGetCounsellorSlotsMutation,
  useUpdateCounsellingMutation,
  useAssignCounsellingMutation,
  useAcceptRescheduledCounselingMutation,
  useGetAvailabilitiesCountsMutation,
  useGetAvailabilitiesSlotListsMutation,
  useGetDashboardQuery,
  useExportCsvMutation,
  useGetAvailabilityWeekWiseQuery,
  useGetDateWiseCounselingListQuery,
  useUpdateCounselorAvailabilityWeekWiseMutation,
  useGetCounselorEarningMutation,
  useAuditCounselingMutation,
  useGetMentorFeedbackDataQuery,
  useUpdateCounselorProfilePictureMutation,
  useDeleteAvailabilityMutation,
  useDisableCounselorMutation,
  useDeleteSessionMutation
} = counsellorAdminApi;

export const { endpoints } = counsellorAdminApi;
export const { getCounselingList } = endpoints;
